import {
    colorBaseRed500,
    IconClose,
    layoutMarginSmall,
    ProductHeading,
    ProductParagraph,
} from '@issuu/silkscreen';
import React, { useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';

import DocumentContext from '../../DocumentPage/DocumentContext';

const CloseBtn = styled(IconClose)`
    position: fixed;
    right: 1em;
    top: 1em;
    fill: ${colorBaseRed500};
`;

const AdTitle = styled.span`
    text-transform: uppercase;
    align-self: start;
    margin: ${layoutMarginSmall} 0;
`;

const HeadingWrapper = styled.span`
    margin: ${layoutMarginSmall} 0;
`;

const ReaderIframe = styled.iframe`
    width: 100%;
    flex-grow: 2;
`;

const TopPart = styled.div`
    flex-grow: 2;
    margin: auto;
    width: 100%;
    max-width: 62em;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export type PromotedDoc = {
    pageNumber: number;
    adId: string;
    docname: string;
    headline: string;
    ownerName: string;
};

type Props = {
    onClose: () => void;
    countdownSecs: number;
    preventAutoClose: () => void;
    promotedDoc: PromotedDoc;
};

export const InterstitialTopPart: React.FC<Props> = ({
    preventAutoClose,
    onClose,
    countdownSecs,
    promotedDoc,
}) => {
    const readerRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const el = readerRef.current;
        if (el) {
            el.addEventListener('mouseenter', preventAutoClose);
            el.addEventListener('mousemove', preventAutoClose);

            return () => {
                el.removeEventListener('mouseenter', preventAutoClose);
                el.removeEventListener('mousemove', preventAutoClose);
            };
        }
    }, [readerRef.current]);

    const { hosts } = useContext(DocumentContext);

    const getReaderUrl = ({ ownerName, docname, pageNumber, adId }: PromotedDoc) => {
        const readerPath = '/issuu-reader3-embed-files/latest/interstitial-reader.html';
        return `//${hosts.embed}${readerPath}?u=${ownerName}&d=${docname}&p=${pageNumber}&adId=${adId}`;
    };

    return (
        <TopPart>
            {countdownSecs > 0 ? null : <CloseBtn onClick={onClose} />}
            <AdTitle>
                <ProductParagraph step="negative-1">Advertisement</ProductParagraph>
            </AdTitle>
            <ReaderIframe allowFullScreen ref={readerRef} src={getReaderUrl(promotedDoc)} />
            <HeadingWrapper>
                <ProductHeading level={6}>{promotedDoc.headline}</ProductHeading>
            </HeadingWrapper>
        </TopPart>
    );
};
